if (!customElements.get('collection-load-more')) {
  customElements.define(
    'collection-load-more',
    class CollectionLoadMore extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.collection-load-more__button');
        if (!this.button) return;

        this.button.addEventListener('click', this.onButtonClick.bind(this));
      }

      onButtonClick(event) {
        event.preventDefault();
        const nextUrl = this.button.dataset.url;
        if (!nextUrl || this.button.classList.contains('loading')) return;

        this.setLoading(true);

        const sectionId = this.dataset.sectionId;
        const fetchUrl = new URL(nextUrl, window.location.origin);
        fetchUrl.searchParams.set('section_id', sectionId);

        fetch(fetchUrl.toString())
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceGrid = html.querySelector('#product-grid');
            const targetGrid = document.querySelector('#product-grid');

            if (sourceGrid && targetGrid) {
              sourceGrid.querySelectorAll('.grid__item').forEach((item) => {
                targetGrid.appendChild(item);
              });
            }

            const sourceLoadMore = html.querySelector('collection-load-more');
            if (sourceLoadMore && sourceLoadMore.querySelector('.collection-load-more__button')) {
              this.innerHTML = sourceLoadMore.innerHTML;
              this.button = this.querySelector('.collection-load-more__button');
              this.button.addEventListener('click', this.onButtonClick.bind(this));
            } else {
              this.remove();
            }

            document
              .getElementById('ProductGridContainer')
              .querySelectorAll('.scroll-trigger')
              .forEach((element) => {
                element.classList.add('scroll-trigger--cancel');
              });

            if (typeof initializeScrollAnimationTrigger === 'function') {
              initializeScrollAnimationTrigger();
            }
          })
          .catch(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        if (!this.button) return;

        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('disabled', isLoading);
        this.button.setAttribute('aria-busy', isLoading);

        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !isLoading);
      }
    }
  );
}
